import * as React from 'react';
import { useDirectors, useOffices, useQuestionsData } from '../../core/api';
import useMobilePhoneStore from '../../zustandStore/mobilePhoneStore';

// Get these public data from API and cached in React Query without showing loading spinner
const AppPublicDataPrefetch: React.FC = () => {
	const setHealthKitAvailability = useMobilePhoneStore((state) => state.setHealthKitAvailability);

	useQuestionsData();
	useOffices();
	useDirectors();

	React.useEffect(() => {
		setHealthKitAvailability();
	}, [setHealthKitAvailability]);

	return null;
};

export default AppPublicDataPrefetch;
